import templates from './templates'
import QRTemplates from './QRTemplates'

const data = {
	templates,
	QRTemplates,
}

export default data
